// /**
//  * Test IDs for the Table component and its sub-components.
//  */
// export const TABLE_TEST_IDS = {
//   /** The container for the entire table header */
//   HEADER: 'table-header',
//   /** Each individual column header, keyed by accessor */
//   COLUMN_HEADER: (accessor: string) => `table-header-col-${accessor}`,
//   /** The chevron/sorting icon for a column */
//   SORT_ICON: (accessor: string) => `table-header-sort-icon-${accessor}`,
//   /** The empty column header for expandable rows */
//   EXPAND_HEADER: 'table-header-expand',
// } as const;

export const TABLE_TEST_IDS = {
  HEADER: 'table-header',
  COLUMN_HEADER: (accessor: string) => `table-header-col-${accessor}`,
  /** * Returns ID like: 'table-header-sort-icon-name' or 
   * 'table-header-sort-icon-name-asc' / 'table-header-sort-icon-name-desc'
   */
  SORT_ICON: (accessor: string, order?: 'asc' | 'desc') => 
    order ? `table-header-sort-icon-${accessor}-${order}` : `table-header-sort-icon-${accessor}`,
  EXPAND_HEADER: 'table-header-expand',
} as const;